export function OnboardingFooter() {
  return (
    <div className="mt-8 text-center">
      <a
        href="https://www.elinia.ai"
        className="text-sm text-muted-foreground hover:text-primary transition-colors"
      >
        ← Voltar à página principal
      </a>
    </div>
  );
}
